<script>

</script>

<template>
  <header class="main-header">
    <div class="main-header--wrapper">
      <div class="main-header--left"></div>
      <div class="main-header--right">
        <div class="main-header--right__text">
          <span class="small-text">Sie haben Fragen?</span>
          <span class="small-text">Kontaktieren Sie uns gern telefonisch</span>
          <a class="main-header__telephone" href="tel:+49 800 3233800"><span class="large-text">+49 800 3233800</span></a>
        </div>
        <a href="tel:+49 800 3233800">
          <div class="main-header--right__icon">
            <i class="fa-solid fa-phone-volume"></i>
          </div>
        </a>
      </div>
    </div>
    <div class="main-header-announcement-wrapper">
      <div class="main-header-announcement">
        <span>Sie sind häufig im Garten? Nutzen Sie den <strong>Johanniter Hausnotruf für Zuhause und unterwegs</strong> für Sicherheit außerhalb der 4 Wände!</span>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
@import '~brandVariables/variables.scss';

// Set a fallback value for $secondary-color if it's not defined
$secondary-color: #eb003c !default;

  .main-header {
    width: 100%;
    height: 81px;
    background: $secondary-color;

    .main-header--wrapper {
      display: flex;
      justify-content: space-between;
      width: 73%;
      margin: 0 auto;

      .main-header--left {
        width: 225px;
        height: 74px;
        background-image: url('../assets/img/Johanniter_logo_header.svg');
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .main-header--right {
        display: flex;
        text-align: right;
        align-content: center;
        flex-wrap: wrap;
        gap: 10px;

        .main-header--right__text {
          display: flex;
          flex-direction: column;
        }

        .main-header--right__icon {
          display: flex;
          align-items: center;

          .fa-solid.fa-phone-volume {
            color: #fff;
            font-size: 25px;
            border: 3px solid #fff;
            border-radius: 50%;
            padding: 10px 10px 8px 8px;
            top: -2px;
            position: relative;
          }
        }

        a {
          text-decoration: none;
        }

        span {
          color: #fff;
          word-wrap: break-word;
          font-weight: 500;
        }

        .small-text {
          font-size: 12px;
          line-height: 14.40px;
        }

        .large-text {
          font-size: 22px;
          line-height: 20px;
        }

        .main-header__telephone {
          color: #fff;
        }
      }
    }

    .main-header-announcement-wrapper {
      background-color: #deff00;

      .main-header-announcement {
        width: 73%;
        margin: 0 auto;
        text-align: center;
        padding: 5px;

        span {
          font-size: 14px;
        }

      }
    }
  }
</style>
